import NivelPrioridadService from 'src/modules/nivelPrioridad/nivelPrioridadService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'NIVELPRIORIDAD_VIEW';

const nivelPrioridadViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPrioridadViewActions.FIND_STARTED,
      });

      const record = await NivelPrioridadService.find(id);

      dispatch({
        type: nivelPrioridadViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPrioridadViewActions.FIND_ERROR,
      });

      getHistory().push('/nivel-prioridad');
    }
  },
};

export default nivelPrioridadViewActions;
